import { createContext, useContext } from 'react';

import { useSessionStorageJson } from '../../utilities/StorageUtilities';
import { buildLinkUrl } from '../links/Link';
import { useDefaultPage } from './DefaultPage';

export const DEFAULT_MENU_LAST_STATE_KEY = 'default-menu-last-state';

/* The code below is all for linking between portal/ui and React (reporting pages only). It should be cleaned up once portal/ui is gone, as this code
   is far more complicated than it needs to be */
export const LastLocationContext = createContext();

export function LastLocationProvider(props) {
    const { children, stateId } = props;

    const [lastLocationState, setLastLocationState] = useSessionStorageJson(stateId || DEFAULT_MENU_LAST_STATE_KEY);

    return (
        <LastLocationContext.Provider value={{ lastLocationState, setLastLocationState }}>
            {children}
        </LastLocationContext.Provider>
    );
}

export function useSetLastLocationState() {
    const { setLastLocationState } = useContext(LastLocationContext);

    return setLastLocationState;
}

export function useLastLocationUrl(defaultUrl) {
    const { lastLocationState } = useContext(LastLocationContext);
    const { defaultPage } = useDefaultPage();

    if (!lastLocationState?.params?.page) {
        return defaultUrl || defaultPage;
    }

    const filterState = lastLocationState?.params?.filterState;
    const page = lastLocationState?.params?.page;

    return buildLinkUrl({ target: page }, null, filterState);
}

export function LastLocationUrl(props) {
    const { children } = props;
    const url = useLastLocationUrl();

    return children(url);
}

export function LastLocation(props) {
    const { children, stateId } = props;

    return (
        <LastLocationProvider stateId={stateId}>
            <LastLocationUrl>{(lastUrl) => children(lastUrl)}</LastLocationUrl>
        </LastLocationProvider>
    );
}
